import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';
import { confirmarConclusaoTreinoGeral } from '../progresso/slices';
import { removerPlano, getOrCreateBackendUser, fetchPlanoList } from '../planos/thunks';

const API_URL = process.env.REACT_APP_API_URL || (window.location.hostname === 'localhost' ? 'http://localhost:5000' : '');

export const setTreinoAtivo = createAsyncThunk('treinos/setTreinoAtivo', async (dia, { rejectWithValue }) => {
    try {
        const backendUser = await getOrCreateBackendUser();

        if (!backendUser.activePlanId) {
            console.warn("Nenhum plano ativo encontrado para selecionar o treino.");
            return rejectWithValue("Nenhum plano ativo encontrado.");
        }

        await axios.patch(`${API_URL}/user/${backendUser._id || backendUser.id}`, { activeDay: dia }, { withCredentials: true });

        return {
            idPlano: backendUser.activePlanId,
            dia: dia,
            userId: backendUser._id || backendUser.id
        };

    } catch (err) {
        console.error("Erro ao atualizar treino ativo no banco:", err);
        return rejectWithValue(err.response?.data?.message || err.message);
    }
});

export const removerTreinoDaAPI = createAsyncThunk('treinos/removerTreinoDaAPI', async ({ idPlano, diaParaRemover, rotinaAtual, confirmarDelecao = false }, { dispatch, rejectWithValue }) => {
    try {
        if (rotinaAtual.length <= 1) {
            if (!confirmarDelecao) {
                // Fix #7: retorna sinal para o componente exibir modal customizado (sem window.confirm bloqueante)
                return { action: 'confirm_delete_plan', idPlano, diaParaRemover };
            }
            dispatch(removerPlano(idPlano));
            return { action: 'removed_full_plan', idPlano, diaParaRemover };
        }

        // Fix #10: endpoint atômico — backend busca estado atual e remove pelo dia (sem race condition)
        await axios.delete(`${API_URL}/planos/${idPlano}/treinos/${diaParaRemover}`, { withCredentials: true });

        dispatch(fetchPlanoList());
        return { id: idPlano, dia: diaParaRemover };
    } catch (err) {
        return rejectWithValue(err.response?.data?.message || err.message || "Erro ao remover treino.");
    }
});


export const adicionarTreinoAoPlano = createAsyncThunk('treinos/adicionarTreinoAoPlano', async ({ idPlano, nomeTreino, exerciciosSelecionados, rotinaAtual }, { dispatch, rejectWithValue }) => {
    try {
        // Fix #11: valida o limite de treinos antes de montar a request
        const MAX_TREINOS = 7;
        if (rotinaAtual.length >= MAX_TREINOS) {
            return rejectWithValue(`Limite de ${MAX_TREINOS} treinos por plano atingido.`);
        }

        const letras = ["A", "B", "C", "D", "E", "F", "G"];
        const letraAtual = letras[rotinaAtual.length];

        const novoTreino = {
            dia: letraAtual,
            foco: nomeTreino || `Treino ${letraAtual}`,
            exercicios: exerciciosSelecionados.map(ex => {
                const { series, repeticoes, ...rest } = ex;
                return {
                    ...rest,
                    grupo: ex.grupo,
                    seriesPadrao: series ?? rest.seriesPadrao ?? 3,
                    repsPadrao: repeticoes ?? rest.repsPadrao ?? 12
                };
            }),
            ativo: false
        };

        const novaRotina = [...rotinaAtual, novoTreino];
        const res = await axios.patch(`${API_URL}/planos/${idPlano}`, { rotina: novaRotina }, { withCredentials: true });
        dispatch(fetchPlanoList());
        return res.data;
    } catch (err) {
        return rejectWithValue(err.response?.data?.message || err.message);
    }
});

export const atualizarTreinoNoPlano = createAsyncThunk('treinos/atualizarTreinoNoPlano', async ({ idPlano, treinoEditado, rotinaAtual }, { dispatch, rejectWithValue }) => {
    try {
        const rotinaAtualizada = rotinaAtual.map((item) =>
            item.dia === treinoEditado.dia
                ? {
                    ...item,
                    foco: treinoEditado.foco || item.foco,
                    exercicios: treinoEditado.exercicios,
                    ativo: treinoEditado.ativo ?? item.ativo,
                }
                : item
        );

        const res = await axios.patch(`${API_URL}/planos/${idPlano}`, { rotina: rotinaAtualizada }, { withCredentials: true });
        dispatch(fetchPlanoList());
        return res.data;
    } catch (err) {
        return rejectWithValue(err.response?.data?.message || err.message);
    }
});

export const finalizarTreino = () => {
    return async (dispatch, getState) => {
        try {
            const { planos } = getState().planosReducer;
            const planoAtivo = planos.find(p => p.ativo) || planos[0];
            if (!planoAtivo || !planoAtivo.rotina) {
                console.warn("Nenhum plano ativo ou rotina encontrada para finalizar treino.");
                return;
            }
            let currentIndex = planoAtivo.rotina.findIndex(t => t.ativo);
            if (currentIndex === -1) currentIndex = 0;
            const diaAtual = planoAtivo.rotina[currentIndex].dia;

            await dispatch(confirmarConclusaoTreinoGeral(diaAtual));

            const nextIndex = (currentIndex + 1) % planoAtivo.rotina.length;
            const proximoDia = planoAtivo.rotina[nextIndex].dia;
            await dispatch(setTreinoAtivo(proximoDia)).unwrap();
        } catch (err) {
            console.error("Erro ao finalizar treino:", err.message);
            throw err;
        }
    };
};
